export default __webpack_public_path__ + "static/media/languages.41009b7b.jpg";